import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";

export default function BackIcon(props) {
  const color = props.highlight ? "#2D3142" : props.color || AppTheme.iconBlack;
  const width = props.width || 20;
  const height = props.height || 20;

  const highlightStyle = props.highlight
    ? {
        backgroundColor: "#F8E585",
        borderRadius: 100,
        padding: 5,
      }
    : {};

  return (
    <TouchableOpacity {...props} style={[appStyles.iconContainer, props.style]}>
      <View style={[highlightStyle]}>
        <Svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25838 12L13.9114 19.9365C14.4169 20.4606 14.3486 21.2498 13.7589 21.699C13.1692 22.1483 12.2815 22.0876 11.776 21.5635L3.33854 12.8135C2.88715 12.3454 2.88715 11.6546 3.33854 11.1865L11.776 2.43653C12.2815 1.91238 13.1692 1.85167 13.7589 2.30095C14.3486 2.75023 14.4169 3.53935 13.9114 4.06351L6.25838 12Z"
            fill={color}
          />
        </Svg>
      </View>
    </TouchableOpacity>
  );
}
